import React, { useState, useEffect } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import { CitasDrawer, DuracionDrawer } from "../components/CitasDrawer";
import ButtonLayout from "../components/ButtonLayout";
import makeRequest from "../components/makeRequest";
import { isLoading } from "expo-font";
import { ActivityIndicator } from "react-native";

export default function (props) {
  const [minutos, setMinutos] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [aforo, setAforo] = useState(null);
  const [time, setTime] = useState({ horas: "--", minutos: "--" });
  const [duracion, setDuracion] = useState(
    props.route.params.instalaciones.duracionCita
  );
  const [maximo, setMaximo] = useState(
    props.route.params.instalaciones.maximaDuracionCita
  );
  const [loading, setLoading] = useState(true);
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [horasNoDisponibles, setHorasNoDisponibles] = useState([]);
  const [aforos, setAforos] = useState([]);

  useEffect(() => {
    const getHoras = async () => {
      const response = await makeRequest(
        "aforos/" +
          new Date(props.route.params.day).getFullYear() +
          "-" +
          (new Date(props.route.params.day).getMonth() < 10
            ? "0" + new Date(props.route.params.day).getMonth()
            : new Date(props.route.params.day).getMonth()) +
          "-" +
          (new Date(props.route.params.day).getDate() < 10
            ? "0" + new Date(props.route.params.day).getDate()
            : new Date(props.route.params.day).getDate()) +
          "/" +
          props.route.params.instalaciones._id,
        "get"
      );
      if (response[0] == 200) {
        setAforos(response[1]);
        setHorasDisponibles([
          ...new Set(
            response[1]
              .filter((e) => {
                console.log(
                  e.reservado +
                    e.extra +
                    parseInt(props.route.params.ninos) +
                    parseInt(props.route.params.adultos)
                );
                if (
                  !(new Date(e.fecha) < new Date(Date.now())) &&
                  e.reservado +
                    e.extra +
                    parseInt(props.route.params.ninos) +
                    parseInt(props.route.params.adultos) <=
                    e.maximo
                )
                  return true;
                else return false;
              })
              .map((e) => {
                return new Date(e.fecha).getHours();
              })
          ),
        ]);

        setLoading(false);
      }
      setLoading(false);
    };
    getHoras();
  }, []);
  useEffect(() => {
    if (time.horas != "--")
      setMinutos(
        aforos
          .filter(
            (e) =>
              new Date(e.fecha).getHours() == parseInt(time.horas) &&
              (new Date(e.fecha).getDate() == new Date().getDate() &&
              new Date(e.fecha).getMonth() == new Date().getMonth() &&
              new Date(e.fecha).getHours() == new Date().getHours()
                ? new Date(e.fecha).getMinutes() > new Date().getMinutes() + 5
                : true)
          )
          .map((e) => new Date(e.fecha).getMinutes())
      );
    setAforo(
      aforos.filter(
        (e) =>
          new Date(e.fecha).getHours() == parseInt(time.horas) &&
          new Date(e.fecha).getMinutes() == parseInt(time.minutos)
      )[0]
    );
    console.log(
      "ESTO" +
        [
          ...new Set(
            aforos
              .filter(
                (e) =>
                  e.reservado +
                    e.extra +
                    parseInt(props.route.params.ninos) +
                    parseInt(props.route.params.adultos) >=
                    e.maximo || e.fecha < new Date(Date.now())
              )
              .map((e) => new Date(e.fecha).getMinutes())
          ),
        ]
    );
    setHorasNoDisponibles([
      ...new Set(
        aforos
          .filter(
            (e) =>
              e.reservado +
                e.extra +
                parseInt(props.route.params.ninos) +
                parseInt(props.route.params.adultos) >=
                e.maximo || e.fecha < new Date(Date.now())
          )
          .map((e) => new Date(e.fecha).getMinutes())
      ),
    ]);
  }, [time]);
  useEffect(() => {
    if (aforo && aforo.fecha)
      setMaximo(
        aforos.filter(
          (y) =>
            new Date(y.fecha) > new Date(aforo.fecha) &&
            y.manana == aforo.manana
        ).length *
          props.route.params.instalaciones.duracionCita <
          props.route.params.instalaciones.maximaDuracionCita
          ? aforos.filter(
              (y) =>
                new Date(y.fecha) > new Date(aforo.fecha) &&
                y.manana == aforo.manana
            ).length * props.route.params.instalaciones.duracionCita
          : props.route.params.instalaciones.maximaDuracionCita
      );
  }, [aforo]);
  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View style={{ flex: 1, justifyContent: "center" }}>
        {!loading && horasDisponibles.length == 0 && (
          <Text
            style={{
              fontFamily: "Nunito-Regular",
              fontSize: 17,
              textAlign: "center",
              lineHeight: 38,
              color: "#3E4672",
              margin: 5,
            }}>
            No hay citas disponibles para este día
          </Text>
        )}
        {!loading && horasDisponibles.length > 0 ? (
          <View>
            <Text
              style={{
                fontFamily: "Nunito-Black",
                fontSize: 44,
                textAlign: "center",
                color: "#3E4672",
                opacity: 0.7,
              }}>
              {time.horas + ":" + time.minutos}
            </Text>
            <Title>Seleccione hora</Title>

            <CitasDrawer
              onChangeHandler={(y) => {
                setTime({ horas: y, minutos: time.minutos });
              }}
              elements={horasDisponibles}
              disabled={[]}
              principal={true}
            />
            <Title>Seleccione minutos</Title>
            <CitasDrawer
              onChangeHandler={(y) => {
                setTime({ horas: time.horas, minutos: y });
                setConfirm(true);
              }}
              elements={minutos}
              disabled={horasNoDisponibles}
            />
            <Title>Seleccione duración</Title>
            <DuracionDrawer
              onChangeHandler={setDuracion}
              disabled={!confirm}
              min={props.route.params.instalaciones.duracionCita}
              max={maximo}
              step={props.route.params.instalaciones.duracionCita}
            />
            {confirm && (
              <ButtonLayout
                text='Continuar'
                onPress={() =>
                  props.navigation.navigate("ConfirmarCita", {
                    aforo: aforo,
                    duracion: duracion,
                    ...props.route.params,
                    time: time,
                  })
                }></ButtonLayout>
            )}
            {!confirm && <View style={{ height: 60 }}></View>}
          </View>
        ) : (
          <></>
        )}
        {loading && (
          <ActivityIndicator size='large' color='rgba(255,255,255, 0.9)' />
        )}
      </View>
      <View></View>
    </BackgroundUser>
  );
}
